import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  status: '',
  hangupCallStatus: false,
  acceptIncomingCallStatus: false,
  muteUnmuteCallStatus: false,
  holdUnholdCallStatus: false,
  isOnCall: false,
  isIncoming: false,
  callState: '',
  activeCallData: null,
  callInfo: null,
  provider: '',
};
export const sliceKey = 'device';

export const deviceSlice = createSlice({
  name: sliceKey,
  initialState,
  reducers: {
    setDeviceStatus: (state, { payload }) => {
      try {
        state.status = payload;
      } catch (e) {
        console.log(e);
      }
    },
    setHangupCallStatus: (state, { payload }) => {
      try {
        state.hangupCallStatus = payload;
      } catch (e) {
        console.log(e);
      }
    },
    setAcceptIncomingCallStatus: (state, { payload }) => {
      try {
        state.acceptIncomingCallStatus = payload;
      } catch (e) {
        console.log(e);
      }
    },
    setMuteUnmuteCallStatus: (state, { payload }) => {
      try {
        state.muteUnmuteCallStatus = payload;
      } catch (e) {
        console.log(e);
      }
    },
    setHoldUnholdCallStatus: (state, { payload }) => {
      try {
        state.holdUnholdCallStatus = payload;
      } catch (e) {
        console.log(e);
      }
    },
    setIsOnCall: (state, { payload }) => {
      try {
        state.isOnCall = payload;
      } catch (e) {
        console.log(e);
      }
    },
    setIsIncoming: (state, { payload }) => {
      try {
        state.isIncoming = payload;
      } catch (e) {
        console.log(e);
      }
    },
    setCallState: (state, { payload }) => {
      try {
        state.callState = payload;
      } catch (e) {
        console.log(e);
      }
    },
    setActiveCallData: (state, { payload }) => {
      try {
        state.activeCallData = payload;
      } catch (e) {
        console.log(e);
      }
    },
    setCallInfoData: (state, { payload }) => {
      try {
        state.callInfo = payload;
      } catch (e) {
        console.log(e);
      }
    },
    setProvider: (state, { payload }) => {
      try {
        state.provider = payload;
      } catch (e) {
        console.log(e);
      }
    },
  },
});

export const {
  setDeviceStatus,
  setHangupCallStatus,
  setAcceptIncomingCallStatus,
  setMuteUnmuteCallStatus,
  setHoldUnholdCallStatus,
  setIsOnCall,
  setIsIncoming,
  setCallState,
  setActiveCallData,
  setCallInfoData,
  setProvider,
} = deviceSlice.actions;

export default deviceSlice.reducer;
